module.exports = __webpack_public_path__ + "img/gfwb20220915.cf2c67cc.jpg";